import React, { useState } from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import './dropdownContent.scss';
export const DropdownContent = ({ children, sectionTitle }) => {
    const [isExpanded, setIsExpanded] = useState(true);
    return (
        <div className='dropdown-container'>
            <div className='display-row'>
                <div className='section-indicator'>{sectionTitle}</div>
                {isExpanded
                    ? <KeyboardArrowUpIcon className='toggle-icon' onClick={() => setIsExpanded(previousValue => !previousValue)} />
                    : <KeyboardArrowDownIcon className='toggle-icon' onClick={() => setIsExpanded(previousValue => !previousValue)} />
                }
            </div>
            <div className='children-container'>
                {isExpanded
                    ? children
                    : <div style={{ padding: '0px 0' }}></div>
                }
            </div>
        </div>
    )
}